import { Component } from 'opus-angular-seed-core';

/**
 * @property uibModalInstance instance of modal
 * @property departments array of possible departments
 * @property roles array of possible roles
 * @property levels array of possible levels
 * @property fieldPrefix prefix of the relation of drl model with main model, eq: licence in licenceDrls
 * @property drl currently selected drl model
 * @property form containing all existing drl sets that are gonna be sent to server
 */
@Component({
    bindings: {
        uibModalInstance: '=',
        departments: '=',
        roles: '=',
        levels: '=',
        fieldPrefix: '=',
        drl: '=',
        form: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'drl.Edit target' | translate }}</h2>
        </div>
        <div class="modal-body">
            <form-wrapper form="vm.form">
                <form-row error="vm.form.errors[vm.field]">
                    <span ng-bind-html="vm.form.errors[vm.field]"></span>
                </form-row>
                <div class="form">
                    <form-row error="vm.form.errors[vm.field].departmentId">
                        <label class="label">{{ 'drl.Department' | translate }}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <ui-select ng-model="vm.department" theme="selectize" title="{{ 'user.Choose department' | translate }}">
                                <ui-select-match placeholder="{{ 'user.Select or search a department in the list...' | translate }}"
                                >{{$select.selected.name}}</ui-select-match>
                                <ui-select-choices repeat="department in vm.departments | filter: $select.search">
                                    <span ng-bind-html="department.name | highlight: $select.search" class="{{department.class}}"></span>
                                </ui-select-choices>
                            </ui-select>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors[vm.field].roleId">
                        <label class="label">{{ 'drl.Role' | translate }}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <ui-select ng-model="vm.role" theme="selectize" title="{{ 'user.Choose role' | translate }}">
                                <ui-select-match placeholder="{{ 'user.Select or search a role in the list...' | translate }}"
                                >{{$select.selected.name}}</ui-select-match>
                                <ui-select-choices repeat="role in vm.roles | filter: $select.search">
                                    <span ng-bind-html="role.name | highlight: $select.search" class="{{role.class}}"></span>
                                </ui-select-choices>
                            </ui-select>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors[vm.field].levelId">
                        <label class="label">{{ 'drl.Level' | translate }}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <ui-select ng-model="vm.level" theme="selectize" title="{{ 'user.Choose level' | translate }}">
                                <ui-select-match placeholder="{{ 'user.Select or search a level in the list...' | translate }}"
                                >{{$select.selected.name}}</ui-select-match>
                                <ui-select-choices repeat="level in vm.levels | filter: $select.search">
                                    <span ng-bind-html="level.name | highlight: $select.search" class="{{level.class}}"></span>
                                </ui-select-choices>
                            </ui-select>
                        </div>
                    </form-row>
                </div>
            </form-wrapper>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary">
                    <button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button>
                </li>
                <li>
                    <button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()"
                    >{{ 'general.Cancel' | translate }}</button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, lodash, FormFactory, CourseService) {
        this.FormFactory = FormFactory;
        this.lodash = lodash;
        this.$translate = $translate;
        this.CourseService = CourseService;
    }

    $onInit () {
        this.field = `${this.fieldPrefix}Drls`;
        this.fieldId = `${this.fieldPrefix}Id`;

        this.departments = this.mapClassifier(this.departments, this.$translate.instant('course.All departments'));
        this.roles = this.mapClassifier(this.roles, this.$translate.instant('course.All roles'));
        this.levels = this.mapClassifier(this.levels, this.$translate.instant('course.All levels'));

        this.initDrl();
    }

    mapClassifier (classifier, defaultName) {
        classifier = classifier.map((val) => ({ name: val.value, id: val.id }));
        classifier.unshift({
            name: defaultName,
            id: undefined,
            class: 'separated'
        });
        return classifier;
    }

    initDrl () {
        const { drl, $translate } = this;
        this.department = { id: drl.departmentId, name: drl.departmentName ? drl.departmentName : $translate.instant('course.All departments') };
        this.role = { id: drl.roleId, name: drl.roleName ? drl.roleName : $translate.instant('course.All roles') };
        this.level = { id: drl.levelId, name: drl.levelName ? drl.levelName : $translate.instant('course.All levels') };
    }

    beforeSave () {
        this.lodash.remove(this.form.model[this.field], { id: this.drl.id });
        const editedModel = {
            id: this.drl.id,
            departmentId: this.department.id,
            roleId: this.role.id,
            levelId: this.level.id
        };
        editedModel[this.fieldId] = this.form.model.id;
        this.form.model[this.field].push(editedModel);
    }

    save () {
        this.beforeSave();
        this.form.save()
            .then(model => this.uibModalInstance.close(model))
        ;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/drls/edit/index.js